"use strict";
// Should be replaced with the table in ui-components when the new design for table is completed (now this table exists only in s4r project)
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnType = exports.Table = void 0;
var table_component_1 = require("./table.component");
Object.defineProperty(exports, "Table", { enumerable: true, get: function () { return table_component_1.Table; } });
var table_constants_1 = require("./table.constants");
Object.defineProperty(exports, "ColumnType", { enumerable: true, get: function () { return table_constants_1.ColumnType; } });
